import { ProductBonus } from '@product/const';
import { StateUtils } from '@spartacus/core';
import { BONUSES } from '../product-state';

export const LOAD_BONUSES = '[CustomProduct] Load Bonuses';
export const SET_BONUSES = '[CustomProduct] Set Bonuses';
export const LOAD_BONUSES_SUCCESS = '[CustomProduct] Load Bonuses Success';
export const LOAD_BONUSES_FAIL = '[CustomProduct] Load Bonuses Fail';
export const RESET_ALL_BONUSES = '[CustomProduct] Reset all Bonuses';

export class LoadBonuses extends StateUtils.EntityLoadAction {
  readonly type = LOAD_BONUSES;

  constructor(public productCode: string) {
    super(BONUSES, productCode);
  }
}

export class LoadBonusesFail extends StateUtils.EntityFailAction {
  readonly type = LOAD_BONUSES_FAIL;

  constructor(
    public productCode: string,
    payload: any,
  ) {
    super(BONUSES, productCode, payload);
  }
}

export class LoadBonusesSuccess extends StateUtils.EntitySuccessAction {
  readonly type = LOAD_BONUSES_SUCCESS;

  constructor(
    public productCode: string,
    public payload: ProductBonus[],
  ) {
    super(BONUSES, productCode, payload);
  }
}

export class SetBonuses implements StateUtils.EntityAction {
  readonly type = SET_BONUSES;
  readonly meta: StateUtils.EntityMeta;

  constructor(
    public productCode: string,
    public payload: ProductBonus[],
  ) {
    this.meta = StateUtils.entityMeta(BONUSES, productCode);
  }
}

export class ResetALLBonuses extends StateUtils.EntityRemoveAllAction {
  readonly type = RESET_ALL_BONUSES;

  constructor() {
    super(BONUSES);
  }
}
